var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { ZdsAccordion, ZdsDivider } from '@zig-design-system/ui-components-react';
import ApiService from '../services/ApiService';
import Alert, { AlertType } from '../../Shared/components/Alert';
import { RootContext } from '../../Context/RootContext';
const Faq = () => {
    const [error, setError] = useState(undefined);
    const [nodes, setNodes] = useState(null);
    const rootContext = useContext(RootContext);
    const apiService = new ApiService(rootContext);
    const nodeIds = useMemo(() => {
        const nodeIdsAttribute = rootContext.pluginContext.startNodeUids;
        return nodeIdsAttribute ? nodeIdsAttribute.split(',') : [];
    }, []);
    useEffect(() => {
        const getNodes = () => __awaiter(void 0, void 0, void 0, function* () {
            const nodes = yield apiService.getNodes(nodeIds);
            if (!nodes || nodes.length === 0) {
                setError('Could not fetch node with ids ' + nodeIds.join(','));
            }
            else {
                setError(null);
                setNodes(nodes);
            }
        });
        getNodes();
    }, [nodeIds]);
    useEffect(() => {
        document.dispatchEvent(new Event('kb:faq:loaded'));
    }, [nodes]);
    if (error) {
        return (React.createElement("div", { className: "default-content" },
            React.createElement(Alert, { message: error, type: AlertType.error })));
    }
    return (React.createElement("div", { className: "zds-row" },
        React.createElement("div", { className: "no-indentation default-content" }, nodes === null || nodes === void 0 ? void 0 : nodes.map((node, index) => (React.createElement(React.Fragment, { key: index },
            React.createElement(ZdsAccordion, { "icon-name": "plus" },
                React.createElement("h4", { slot: "header" }, node.title),
                React.createElement("div", { slot: "body", dangerouslySetInnerHTML: { __html: node.content[0].html } })),
            nodes.length - 1 != index && React.createElement(ZdsDivider, null)))))));
};
export default Faq;
